import React, { useEffect, useState } from "react";
import { CircularProgress, Backdrop } from "@mui/material";
import Layout from "../components/Layout";
import { getAllCourses, getAllUviForAdmin } from "../service/service"; // Import the service function
import CourseReviewGrid from "../components/CourseReviewGrid";

const ReviewVoiceNotes = () => {
  const [courses, setCourses] = useState([]);
  const [uviCounts, setUviCounts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true); // Start loading
      try {
        const data = await getAllCourses(); // Call the service function
        setCourses(data.data); // Set courses in state
      } catch (error) {
        console.error("Failed to fetch courses:", error);
      } finally {
        setLoading(false); // Stop loading
      }
    };

    fetchCourses(); // Fetch courses when the component mounts
  }, []);

  // Fetch UVI counts and update the badge when courses change
  useEffect(() => {
    if (!courses.length) return;

    const fetchAllUvi = async () => {
      try {
        // Create an object mapping course IDs to their UVI counts
        const counts = Object.fromEntries(
          await Promise.all(
            courses.map(async (course) => [
              course._id,
              (await getAllUviForAdmin(course._id, course.name)).length,
            ]),
          ),
        );
        setUviCounts(counts);
      } catch (error) {
        console.error("Failed to fetch UVIs:", error);
      }
    };

    fetchAllUvi();
  }, [courses]);

  return (
    <Layout>
      {loading ? ( // Show loading indicator
        <Backdrop open={loading} sx={{ zIndex: 1 }}>
          <CircularProgress />
        </Backdrop>
      ) : (
        <CourseReviewGrid
          title="Voice notes"
          description="Review learner voice submissions by course."
          courses={courses}
          counts={uviCounts}
          actionLabel="Review notes"
          to={(course) => `/voice-notes/${course._id}/${course.name}`}
        />
      )}
    </Layout>
  );
};

export default ReviewVoiceNotes;
